import React from 'react';
import { FormControl, TextArea } from '@withjoy/joykit';
import { FormikProps } from 'formik';
import { PlaceToStayFormFields } from '../PlaceToStayForm.types';
import { StyledTextAreaContainer } from '../PlaceToStayComponent.styles';
import { useFieldErrors } from '@shared/createEvent/hooks/useFieldErrors';
import { useTranslation } from '@shared/core';

const MAX_LENGTH = 1500;

interface PlaceToStayNoteFieldProps
  extends Readonly<{
    formik: FormikProps<PlaceToStayFormFields>;
  }> {}

export const PlaceToStayNoteField: React.FC<PlaceToStayNoteFieldProps> = ({ formik }) => {
  const { tq } = useTranslation('placeToStayComponent');
  const getFieldErrorProps = useFieldErrors<PlaceToStayFormFields>(formik);

  const getLengthOfStringField = (key: keyof PlaceToStayFormFields): number => {
    const value = formik.values[key];
    if (value && typeof value === 'string') {
      return value.length;
    }
    return 0;
  };

  return (
    <FormControl
      marginTop={2}
      isRequired={false}
      caption={`${getLengthOfStringField('note')}/${MAX_LENGTH}`}
      overrides={{ Hint: { props: { color: 'mono10', textAlign: 'right' } } }}
      label={tq`Note for Guests`}
      {...getFieldErrorProps('note')}
    >
      <StyledTextAreaContainer isInvalid={getFieldErrorProps('note').isInvalid}>
        <TextArea
          {...formik.getFieldProps('note')}
          maxLength={MAX_LENGTH}
          placeholder={tq`A note to share with your guests about this hotel.`}
          resize="vertical"
        />
      </StyledTextAreaContainer>
    </FormControl>
  );
};
